import * as TYPES from '../types';

const initialState = {
    trainingCategoryList: [],
    trainingList: []
};

export function TrainingReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {

        case TYPES.GET_ALL_TRAINING_CATEGORY_SUCCESS:
            return {
                ...preState,
                trainingCategoryList: payload,
            };

        case TYPES.GET_ALL_TRAINING_SUCCESS:
            return {
                ...preState,
                trainingList: payload,
            };

        default:
            return state;
    }
}